<template>
	<div
		class="event-list-item-actions"
		:class="[`-${variant ?? 'none'}`]"
	>
		<div class="event-list-item-actions__event-link-icon">
			<div
				v-if="showWatchLabel"
				class="event-list-item-actions__event-link-icon-text"
			>
				{{ $I18n.trans('arena.watch_game') }}
			</div>
			<Icon icon-name="button-play-filled" />
		</div>
		<div
			v-if="couchModeAvailable"
			class="event-list-item-actions__couchmode-button"
			@click.prevent="$emit('open-couch-mode')"
		>
			<Icon
				icon-name="sofa"
				size="xl"
			/>
		</div>
	</div>
</template>

<script>
import Icon from '@shared/components/Icon';

export default {
	name:       'EventListItemActions',
	components: { Icon },
	props:      {
		couchModeAvailable: {
			type:    Boolean,
			default: false,
		},
		showWatchLabel: {
			type:    Boolean,
			default: false,
		},
		variant: {
			type:    String,
			default: null,
		},
	},
	emits: ['open-couch-mode'],
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.event-list-item-actions {
	display: none;

	&.-volley {
		flex-grow: 1;
	}

	@include size(md-up) {
		display: flex;
		flex-shrink: 0;
		justify-content: flex-end;
	}
}

.event-list-item-actions__event-link-icon {
	display: none;
	opacity: 0;
	color: var(--color-hype-yellow);
	transition: opacity $trans-time-fast;

	@include is-touch {
		opacity: 1;
	}

	@include size(md-up) {
		display: flex;
		align-items: center;
		justify-content: center;
	}
}

.event-list-item-actions__event-link-icon-text {
	margin-right: $sp3;
}

.event-list-item-actions__couchmode-button {
	display: flex;
	position: relative;
	margin-left: $sp5;
	padding-left: $sp5;
	align-items: center;
	justify-content: center;

	&::after {
		content: '';
		display: block;
		position: absolute;
		top: 50%;
		left: 0;
		transform: translateY(-50%);
		width: 1px;
		height: 40%;
		opacity: 0;
		background-color: var(--color-grey-700);
		transition: opacity $trans-time-fast;
	}

	body.-t-light & { // stylelint-disable-line selector-no-qualifying-type
		color: var(--color-grey-700);
	}

	&:focus,
	&:hover {
		color: var(--color-hype-yellow);

		body.-t-light & { // stylelint-disable-line selector-no-qualifying-type
			color: var(--color-hype-yellow);
		}
	}

	@include is-touch {
		&::after {
			opacity: 1;
		}
	}
}
</style>
